export default __webpack_public_path__ + "static/media/soy_bean.099fa3b0.jpeg";